import React from 'react';
import { IFormatterProps } from '../../../@types/workspaceTypes';
import { IProduct, ISalesInvoiceLine } from '../../../graphql/schema/p4types';
import { Tooltip } from '@fluentui/react-components';

const AliasFormatter = (props: IFormatterProps<IProduct | ISalesInvoiceLine>) => {
  const aliases = props.dependentValues?.rowData?.alias ?? props.dependentValues?.rowData?.product.alias;
  const aliasesCsv = Array.isArray(aliases) ? aliases.map((a) => a?.reference).join(',') : '';
  return (
    <Tooltip content={aliasesCsv} relationship={'label'}>
      <div>{aliasesCsv}</div>
    </Tooltip>
  );
};

export default AliasFormatter;
